import { useQuery } from "@tanstack/react-query";
import { documentosApi } from "@/features/documentos/services/documentos.api";
import { qk } from "@/lib/query-keys";

/**
 * Gestión Documental (fase 2) · requisitos del expediente de la solicitud (arman el paso
 * «Documentos»). Se refresca cuando cambian los documentos de la solicitud (el llamador pasa
 * su conteo como `version`) y al subir/eliminar (las mutaciones invalidan la llave).
 */
export function useRequisitosExpediente(solicitudId: string, version: number) {
  return useQuery({
    queryKey: [...qk.requisitosExpediente(solicitudId), version],
    queryFn: () => documentosApi.requisitos(solicitudId),
    placeholderData: (previo) => previo,
  });
}
